"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "positive": "#1bb84b",
    "positive-container": "#e8fcee",
    "alert": "#fcb121",
    "alert-container": "#feedcd",
    "negative": "#eb2727",
    "negative-container": "#fde7e7",
    "insight": "#4c2deb",
    "insight-container": "#ebe8fd",
    "on-container": "#1a1a1a",
    "backdrop-white": "rgba(255, 255, 255, 0.8)",
    "backdrop-black": "rgba(26, 26, 26, 0.6)",
};
// Path: src/tokens/colors/feedback.ts
//# sourceMappingURL=feedback.js.map